import { createI18n } from 'vue-i18n'
import zhCN from "../../public/i18n/locales/zh-cn";
import enUS from '../../public/i18n/locales/en-us';
import lao from '../../public/i18n/locales/lao';

// 读取存储的初始语言
const savedLang = localStorage.getItem('lang') || 'en-us';

const i18n = createI18n({

  locale: savedLang,
  fallbackLocale: savedLang,
  allowComposition: true,
  globalInjection: true,
  messages: {}
})

export function loadLocaleMessages(locale) {
  try {
    //debugger;
    // 生产环境使用版本号，开发环境使用时间戳
    const cacheBuster = `t=${new Date().getTime()}`
    //import.meta.env.PROD ? `v=${process.env.VITE_APP_VERSION}`  : `t=${new Date().getTime()}`;

    // const module = await import(`../../public/i18n/locales/${locale}.js`);//?${cacheBuster}
    // const moduledefault = module.default;

    debugger
    let module ={};
    if (locale === "en-us") {
      module = enUS
    }
    else if (locale === "zh-cn") {
      module = zhCN
    } else if (locale === "lao") {
      module = lao
    }
    const moduledefault = module;
    i18n.global.setLocaleMessage(locale, moduledefault);
    localStorage.setItem('lang', locale);
    return moduledefault;
  } catch (error) {
    console.error('Error loading locale:', error);
    throw error; // 抛出错误让调用方处理
  }
}

export default i18n;